import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { Container } from './Container';
import { CTAButton } from './CTAButton';
import { ProductMockup } from './ProductMockup';
import { TrustRow } from './TrustRow';
import { OfferTimer } from './OfferTimer';
import { SeatsToday } from './SeatsToday';
import { bonuses, offerItems } from '../data/landing';
import { usePricing } from '../hooks/usePricing';
function CheckItem({
  children
}: {
  children: React.ReactNode;
}) {
  return <li className="flex items-start gap-3 text-[15px] text-white sm:text-base" data-id="element-279" data-mp="1s93zbb7eqj2f">
      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-teal-light text-navy" data-id="element-280" data-mp="1x8qbrifevva6">
        <CheckIcon aria-hidden="true" className="h-3 w-3" strokeWidth={3} data-id="element-281" data-mp="228colqrbv9ig" />
      </span>
      {children}
    </li>;
}
export function PricingSection() {
  const {
    price,
    regularPrice,
    launchActive
  } = usePricing();
  return <section id="oferta" aria-labelledby="offer-title" className="scroll-mt-4 bg-navy py-16 text-white sm:py-20 lg:py-24" data-id="element-282" data-mp="7ul8q9ientek">
      <Container data-id="element-283" data-mp="1mirdylkt8f1q">
        <div className="text-center" data-id="element-284" data-mp="1hpy9zzx61aqp">
          {launchActive && <p className="font-display text-xs font-extrabold uppercase tracking-[0.14em] text-teal-light sm:text-sm" data-id="element-285" data-mp="1hon5fxvwbyyj">Precio de lanzamiento</p>}
          <h2 id="offer-title" className="mt-2 font-heading text-[2rem] font-black leading-[1.1] text-white sm:text-4xl lg:text-[2.85rem]" data-id="element-286" data-mp="17sac5149jn4b">
            Tu pack completo
          </h2>
        </div>

        <div className="mx-auto mt-10 grid max-w-5xl overflow-hidden rounded-[1.75rem] bg-white/[0.05] ring-2 ring-pink/60 lg:grid-cols-[1fr_1fr]" data-id="element-287" data-mp="20fxwqg5jadqy">
          <div className="p-5 sm:p-10" data-id="element-288" data-mp="1vfjmqskdgtqa">
            <ProductMockup tone="dark" decorated={false} className="mx-auto w-full max-w-[380px]" data-id="element-289" data-mp="1rg198huvrkxh" />
            <ul className="mt-8 grid gap-3" data-id="element-290" data-mp="k1xugyj7uc0j">
              {offerItems.map(item => <CheckItem key={item} data-id="element-291" data-mp="g0uhqkwgsw3j">{item}</CheckItem>)}
            </ul>
            <p className="mt-6 flex items-center gap-2 font-display text-sm font-extrabold uppercase tracking-[0.12em] text-teal-light" data-id="element-292" data-mp="g2ys9lovctcs">
              <GiftIcon aria-hidden="true" className="h-4 w-4" data-id="element-293" data-mp="mh4cl9dnfoli" />+ 5 bonos incluidos
            </p>
            <ul className="mt-3 grid gap-3" data-id="element-294" data-mp="7kdgpa36ov0n">
              {bonuses.map(b => <CheckItem key={b.number} data-id="element-295" data-mp="ci5fmo28xhec">{b.title}</CheckItem>)}
            </ul>
          </div>

          <div className="flex flex-col justify-center border-t border-white/10 bg-white/[0.05] p-5 text-center sm:p-10 lg:border-l lg:border-t-0" data-id="element-296" data-mp="3uwebk8m8sdp2">
            <OfferTimer className="mb-7" data-id="element-297" data-mp="3k39xv7ki0kq" />
            <div data-id="element-298" data-mp="3kz06t69oldcl">
              {regularPrice && <p className="text-xl font-semibold text-white/70 line-through decoration-pink decoration-2" data-id="element-299" data-mp="3kwdrulkgnvkc">{regularPrice}</p>}
              <p className="font-heading text-[3.25rem] font-black leading-none tracking-tight text-sun sm:text-[4rem]" data-id="element-300" data-mp="3bxa95ip7hi6d">{price}</p>
              <p className="mt-3 text-sm text-white/90 sm:text-base" data-id="element-301" data-mp="3fy3xueah310b">Pago único · Sin suscripciones · Acceso de por vida</p>
            </div>
            <CTAButton label="Quiero mis 30 días resueltos" location="oferta" fullWidth className="mt-8" data-id="element-302" data-mp="2sc07vd020d9f" />
            <SeatsToday className="mt-4" data-id="element-303" data-mp="36brpdnps4bs6" />
            <TrustRow tone="dark" align="center" className="mt-5" data-id="element-304" data-mp="36cks8dlmah51" />
          </div>
        </div>
      </Container>
    </section>;
}